import { render, staticRenderFns } from "../templates/normal_fcont_84.html?vue&type=template&id=15165438&"
import script from "./normal_fcont_84.vue?vue&type=script&lang=js&"
export * from "./normal_fcont_84.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports